if (!customElements.get('spyhold-stock-notice')) {
  customElements.define('spyhold-stock-notice', class extends HTMLElement {
    connectedCallback() {
      this.states = JSON.parse(this.querySelector('script').textContent);
      this.scope = this.closest('.shopify-section') || this.parentElement;
      this.sync = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          const input = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          this.update(input ? input.value : this.dataset.initialVariant);
        }, 0);
      };
      this.scope.addEventListener('change', this.sync);
      this.scope.addEventListener('click', this.sync);
    }
    update(id) {
      this.querySelector('[data-spyhold-low-stock]').hidden = this.states[id] !== true;
      this.scope.querySelectorAll('.spyhold-ptag [data-spyhold-low-stock]').forEach(badge => {
        badge.hidden = this.states[id] !== true;
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.scope.removeEventListener('change', this.sync);
      this.scope.removeEventListener('click', this.sync);
    }
  });
}
